import React, { useEffect, useState } from 'react'

import {
  SweetspotMark,
  sweetspotMarkSrc,
} from '@/components/common/SweetspotMark'

interface SweetspotMarkLoadingProps {
  size?: number
  startDelayMs?: number
  className?: string
}

const ANIMATED_VARIANT = 'nopulse-markstart'

export const SweetspotMarkLoading: React.FC<SweetspotMarkLoadingProps> = ({
  size = 64,
  startDelayMs = 2500,
  className,
}) => {
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    // Warm the browser cache so the src swap is instant rather than
    // showing a blank frame while the animated variant fetches.
    const preload = new window.Image()
    preload.src = sweetspotMarkSrc(ANIMATED_VARIANT)

    const timer = setTimeout(() => setAnimating(true), startDelayMs)
    return () => clearTimeout(timer)
  }, [startDelayMs])

  return (
    <SweetspotMark
      variant={animating ? ANIMATED_VARIANT : 'static'}
      size={size}
      className={className}
    />
  )
}

export default SweetspotMarkLoading
